import { render } from "./App.vue?vue&type=template&id=46c5f291"
const script = {}

import exportComponent from "/Users/admin/Documents/Works/fast_energy_task_manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__